import React, { FC } from 'react';

import styles from './Banner.module.scss';

interface IBannerProps {
  text: string | JSX.Element;
}

export const Banner: FC<IBannerProps> = ({ text }) => <div className={styles.banner}>{text}</div>;